import _request from '@/utils/request.js'

var _approval = {
    // 根据业务标识查询审批任务详情列表
    getByBusinessCodeTaskList (info, resolve, reject) {
        _request.api({
            url     : _request.getApprovalUrl("/approval/appTask/getByBusinessCodeTaskList"),
            params  : info,
            method  : 'get',
            success : resolve,
            error   : reject
        })
    },
}

export default _approval